import jwt from '@/http/requests/auth/jwt'

export default {

  fetchOrganisations ({ commit }) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/organisation/list')
        .then((response) => {
          commit('SET_ORGANISATIONS', response.data.items)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOrganisationUsers (context, organisationId) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/organisationuser/list', { idOrganisation: organisationId })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOrganisation (context, organisationId) {
    return new Promise((resolve, reject) => {
      const url = organisationId ? `/api/admin/organisation/${organisationId}` : "/api/admin/organisation/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveOrganisation (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/organisation/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOrganisationUser (context, id) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/organisationuser/${id}`)
        .then((response) => {
          resolve(response.organisationUser)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUnmappedUsers ({ commit }, idOrganisation) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/organisation/${idOrganisation}/users/unmapped`)
        .then((response) => {
          commit('SET_UNMAPPED_USERS', response.data.items)
          resolve(response.data.items)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveOrganisationUser (context, updatedData) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/organisationuser/${updatedData.id}`)
        .then((response) => {
          const data = response.data.organisationUser
          Object.assign(data, updatedData)
          jwt.post('/api/admin/organisationuser/save', data)
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { reject(error) })
        }).catch((error) => { reject(error) })

    })
  },
  addOrganisationUsers (context, payload) {
    return jwt.post(`/api/admin/organisation/${payload.id}/users/add`, payload)
  },
  inviteOrganisationUser (context, payload) {
    return jwt.post(`/api/admin/organisationuser/invite`, payload)
  },
  deleteOrganisationUser (context, id) {
    return jwt.post(`/api/admin/organisationuser/delete`, { id })
  },
  removeRecord ({ commit }, organisationId) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/organisation/delete/${organisationId}`)
        .then((response) => {
          commit('REMOVE_RECORD', organisationId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
